var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 21.4",
    style: {
      enableBackground: "new 0 0 19 21.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8A01E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz48-2",
    className: "st0",
    d: "M3,21.4c-1,0-1.8-0.8-1.8-1.8c0,0,0,0,0,0v-17H0V0.9h5.6V0h7.9v0.9 h5.6v1.8h-1.2v17c0,1-0.8,1.8-1.8,1.8H3z M16,2.7H3v17h13V2.7z M6.2,17.1h1.8V5.2H6.2V17.1z M11.1,17.1h1.8V5.2h-1.8L11.1,17.1z  M3,2.7L3,2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.8942eb426c517550afefc4e4e1e06224.svg";
export { ForwardRef as ReactComponent };